import { NavLink, useLocation } from 'react-router-dom'

import { IRoleEnum } from '../../../../types/router'

import { joinClassNames } from '../../../../utils/styles'
import styles from './menu-item.module.scss'

export interface IMenuItem {
    title: string
    url: string
    image: string
    role: IRoleEnum[]
    enabled: boolean
}

interface IMenuItemProps {
    menuItem: IMenuItem
}

function MenuItem(props: IMenuItemProps) {
    const { title, url, image: IconComponent } = props.menuItem

    const location = useLocation()

    const [, firstUrlSegment] = location.pathname.split('/')

    return (
        <NavLink
            className={({ isActive }) =>
                joinClassNames(
                    styles.menuItem__btn,
                    (isActive ||
                        (firstUrlSegment && url.includes(firstUrlSegment))) &&
                        styles.menuItem__btnActive
                )
            }
            to={url}
        >
            <IconComponent />
            <p className={styles.menuItem__title}>{title}</p>
        </NavLink>
    )
}

export default MenuItem
